// extracted by mini-css-extract-plugin
module.exports = {"container":"stylesLayout_container__Ef3Sv","icon":"stylesLayout_icon__sFNxd","title":"stylesLayout_title__3MYhN"};